<template>

    <div>
        
        <div class="loading" v-show="loading">Loading&#8230;</div>

        <!--================Header Menu Area =================-->
        <Header />
        <!--================Header Menu Area =================-->

        <!--================Header Menu Area =================-->
        <BannerContact />
        <!--================Header Menu Area =================-->

        <div id="contact">
            <section class="contact_area p_120">
                <div class="container">

                    <div class="col-lg-12">
                        <h3 class="text-heading title_color"> <i class="fas fa-hand-point-up"></i> Clique nos ícones</h3>
                    </div>

                    <div class="row">

                        <div class="col-lg-6">

                            <div class="contact_info">

                                <div class="info_item">
                                    <h6><a href="tel:+556133754222"><i class="fas fa-phone"></i> (61) 3375-4222</a></h6>
                                    <p>De segunda a sexta das 08h às 18h </p>
                                </div>

                                <div class="info_item">
                                    <h6><a href="mailto:contato@dlealp.com.br"><i class="fas fa-envelope"></i> contato@dlealp.com.br</a></h6>
                                    <p>Se preferir, utilize o formulário</p>

                                    <form class="row contact_form" @submit.prevent="handleSubmit" id="contactForm" >
                                            <div class="col-md-12">
                                                <div class="alert alert-success" v-if="msgSuccess"> Mensagem encaminhada com sucesso</div>
                                                <div class="alert alert-danger" v-if="msgError"> Erro no envio da mensagem. <a href="mailto:contato@dlealp.com.br"> Clique aqui e encaminhe através do seu email</a></div>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" id="name" name="name" placeholder="Nome" v-model="msg.name" required>
                                                </div>
                                                <div class="form-group">
                                                    <input type="email" class="form-control" id="email" name="email" placeholder="email" v-model="msg.mail" required>
                                                </div>
                                                <div class="form-group">
                                                    <input type="text" class="form-control" id="subject" name="subject" placeholder="Assunto" v-model="msg.subject" required>
                                                </div>
                                                <div class="form-group">
                                                    <textarea class="form-control" name="message" id="message" rows="1" placeholder="Mensagem" v-model="msg.msg" required></textarea>
                                                </div>

                                                <div class="form-group">
                                                    <vue-recaptcha sitekey="6LczIdUUAAAAALzXgWfEtZixI9KtbskPNmUwu5YZ" @verify="onVerify"></vue-recaptcha>
                                                </div>

                                                <button type="submit" value="submit" class="btn submit_btn">Enviar mensagem</button>
                                            </div>
                                        
                                    </form>

                                </div>

                            </div>
                        </div>

                        <div class="col-lg-6">

                            <div class="contact_info">
                                <div class="info_item">
                                    <h6><a href="https://goo.gl/maps/KbTaQVaSW2MKCC8EA" target="_blank"><i class="fas fa-map-marker-alt"></i> Ceilândia</a></h6>
                                    <p>SMC Quadra 01 Lote 65
                                    <br/>CEP: 72265-700</p>
                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3839.172927020194!2d-48.14857818476305!3d-15.794833227174488!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935bcbe2d4bda38d%3A0x7d4fad13eb351631!2sD&#39;Lealp%20Interiores!5e0!3m2!1spt-BR!2sbr!4v1580844293633!5m2!1spt-BR!2sbr" width="100%" height="310" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Clients />

        <!--================Footer Area =================-->
        <Footer />
        <!--================End Footer Area =================-->
    </div>

</template>

<script>
    import axios from 'axios';
    import {apiURL} from '../resources/apiUrl'
    import Vue from 'vue';
    import SmoothScroll from 'smooth-scroll';
    import $ from 'jquery';

    import Header from '../components/header';
    import BannerContact from '../components/banner_contact';
    import Clients from '../components/clients';
    import Footer from '../components/footer';

    import VueRecaptcha from 'vue-recaptcha';

    let instance = axios.create();

    export default {

        name: 'contato',

        components: {
            Header,
            BannerContact,
            Clients,
            Footer,
            VueRecaptcha    
        },

        data() {
            return {
                loading: false,
                msg: {
                    name: '',
                    mail: '',
                    subject: '',
                    msg: '',
                    recaptcha_token: null
                },
                msgSuccess: false,
                msgError: false,
            }
        },

        mounted() {
            let nav_offset_top = $('header').height() + 50;
            if ( $('.header_area').length ){ 
                $(window).scroll(function() {
                    var scroll = $(window).scrollTop();   
                    if (scroll >= nav_offset_top ) {
                        $(".header_area").addClass("navbar_fixed");
                    } else {
                        $(".header_area").removeClass("navbar_fixed");
                    }
                })
            }
            let scroll = new SmoothScroll('a[href*="#"]');
            $('.nav a').on('click', function(){
                $('.navbar-toggler').click();
            });
        },

        created() {},

        updated() {},

        methods: {

            onVerify: function (response) {
                this.msg.recaptcha_token = response;
            },

            handleSubmit (e) {

                if(this.msg.recaptcha_token == null){
                
                    alert('Formulário inválido');
                
                }else{

                    this.loading = true;

                    instance.post(`${apiURL()}/lp/contact`, this.msg)

                        .then( response => 
                            {
                            this.msgSuccess = true;
                            this.msgError = false;
                            this.loading = false; 
                            }
                        )
                        .catch(  error =>

                            {
                                this.msgSuccess = false;
                                this.msgError = true;
                                this.loading = false;
                            }

                        );

                }

            }

        },

    }
</script>

<style>

/* CSS Only for loading */

/* Absolute Center Spinner */
.loading {
    position: fixed;
    z-index: 999;
    height: 2em;
    width: 2em;
    overflow: show;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
}

/* Transparent Overlay */
.loading:before {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0, .8));

    background: -webkit-radial-gradient(rgba(20, 20, 20,.8), rgba(0, 0, 0,.8));
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
    /* hide "loading..." text */
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.loading:not(:required):after {
    content: '';
    display: block;
    font-size: 10px;
    width: 1em;
    height: 1em;
    margin-top: -0.5em;
    -webkit-animation: spinner 1500ms infinite linear;
    -moz-animation: spinner 1500ms infinite linear;
    -ms-animation: spinner 1500ms infinite linear;
    -o-animation: spinner 1500ms infinite linear;
    animation: spinner 1500ms infinite linear;
    border-radius: 0.5em;
    -webkit-box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
    box-shadow: rgba(255,255,255, 0.75) 1.5em 0 0 0, rgba(255,255,255, 0.75) 1.1em 1.1em 0 0, rgba(255,255,255, 0.75) 0 1.5em 0 0, rgba(255,255,255, 0.75) -1.1em 1.1em 0 0, rgba(255,255,255, 0.75) -1.5em 0 0 0, rgba(255,255,255, 0.75) -1.1em -1.1em 0 0, rgba(255,255,255, 0.75) 0 -1.5em 0 0, rgba(255,255,255, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-moz-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@-o-keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
@keyframes spinner {
    0% {
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

</style>